import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useApp } from '../../../contexts/AppContext';
import Button from '../../ui/Button';

const REASON_COPY = {
  clerk_no_token: 'Your Canva account is no longer linked to TurboSync Pro.',
  canva_token_rejected: 'Your Canva connection has expired or your Canva password may have changed.',
};

const DEFAULT_COPY = 'TurboSync Pro can\'t reach your Canva account.';

export default function CanvaAuthBanner() {
  const { state } = useApp();
  const navigate = useNavigate();
  const failure = state.canvaAuthFailure;

  if (!failure) return null;

  const explanation = REASON_COPY[failure.reason] || DEFAULT_COPY;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.25 }}
        className="mb-4 squircle bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 px-4 py-3"
      >
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-0.5">
            <AlertTriangle className="w-5 h-5 text-red-600 dark:text-red-400" strokeWidth={2} />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-body-sm font-semibold text-red-900 dark:text-red-100">
              Canva connection needs attention
            </p>
            <p className="text-caption text-red-800 dark:text-red-300 mt-0.5">
              {explanation} Auto-sync is paused until you reconnect.
            </p>
          </div>

          <div className="flex-shrink-0">
            <Button
              onClick={() => navigate('/settings')}
              variant="primary"
              size="sm"
            >
              Reconnect Canva
            </Button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
